import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import { FormLayout } from 'molecules/Form';

type SingleInputFormProps = FormProps & { layout?: FormLayout; successMessageClassName?: string };

const SingleInputForm: FC<SingleInputFormProps> = ({
  id,
  successMessage,
  successfulSubmit,
  isLoading,
  layout,
  successMessageClassName = 'text-white',
}) => (
  <div>
    {isLoading && (
      <div className="flex w-full items-center justify-center">
        <div className="aspect-square w-12 animate-loading rounded-[50%] border-8 border-primary-300" />
      </div>
    )}

    {successfulSubmit && successMessage ? (
      <div className={successMessageClassName}>{successMessage}</div>
    ) : (
      <form id={id} className={twJoin('singleInput-form', layout === 'stacked' && 'singleInput-form--stacked')} />
    )}
  </div>
);

export default SingleInputForm;
